'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('babel-polyfill');

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Formit = function (_React$Component) {
  _inherits(Formit, _React$Component);

  function Formit() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, Formit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Formit.__proto__ || Object.getPrototypeOf(Formit)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      posting: false,
      fields: [],
      responseData: null,
      postingError: null
    }, _this.setValue = function (fieldName, value) {
      var _this$state = _this.state,
          posting = _this$state.posting,
          fields = _this$state.fields;

      if (posting) return false;
      var existsIndex = fields.findIndex(function (f) {
        return f.name === fieldName;
      });

      if (existsIndex > -1) {
        fields[existsIndex].value = value;
        _this.setState({ fields: fields });
        return true;
      }

      _this.setState({
        fields: [].concat(_toConsumableArray(fields), [{ name: fieldName, value: value, error: null }])
      });

      return true;
    }, _this.getValue = function (fieldName) {
      var fields = _this.state.fields;

      var field = fields.find(function (f) {
        return f.name === fieldName;
      });
      return field ? field.value : '';
    }, _this.getFieldError = function (fieldName) {
      var fields = _this.state.fields;

      var field = fields.find(function (f) {
        return f.name === fieldName;
      });
      return field ? field.error : null;
    }, _this.clearValues = function () {
      var posting = _this.state.posting;

      if (posting) return false;
      _this.setState({ fields: [], postingError: null, responseData: null });
      return true;
    }, _this.submit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var _this$props, action, headers, responseAsJSON, _this$state2, posting, fields, formData, head, responseData, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, action = _this$props.action, headers = _this$props.headers, responseAsJSON = _this$props.responseAsJSON;
                _this$state2 = _this.state, posting = _this$state2.posting, fields = _this$state2.fields;
                formData = new FormData();
                head = new Headers();
                responseData = void 0;


                e.preventDefault();

                if (!posting) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', false);

              case 8:
                _this.setState({ posting: true, postingError: null, responseData: null });

                fields.forEach(function (f) {
                  formData.append(f.name, f.value);
                });

                if (headers) {
                  headers.forEach(function (h) {
                    for (var p in h) {
                      head.append(p, h[p]);
                    }
                  });
                }

                _context.prev = 11;
                _context.next = 14;
                return fetch(action, {
                  method: 'POST',
                  headers: head,
                  body: formData
                });

              case 14:
                response = _context.sent;

                if (!responseAsJSON) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return response.json();

              case 18:
                responseData = _context.sent;
                _context.next = 24;
                break;

              case 21:
                _context.next = 23;
                return response.text();

              case 23:
                responseData = _context.sent;

              case 24:

                _this.setState({
                  posting: false,
                  fields: [],
                  responseData: responseData
                });
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t0 = _context['catch'](11);

                _this.setState({
                  posting: false,
                  postingError: _context.t0
                });

              case 30:
                return _context.abrupt('return', true);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 27]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Formit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var hiddenFields = this.props.hiddenFields;


      if (hiddenFields && hiddenFields.length > 0) {
        var _fields = hiddenFields.map(function (f) {
          return Object.assign({}, f, { error: null });
        });

        this.setState({ fields: _fields });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          posting = _state.posting,
          postingError = _state.postingError,
          responseData = _state.responseData;


      return children({
        onSubmit: this.submit,
        setValue: this.setValue,
        getValue: this.getValue,
        getFieldError: this.getFieldError,
        clearValues: this.clearValues,
        isPosting: posting,
        postingError: postingError,
        responseData: responseData
      });
    }
  }]);

  return Formit;
}(React.Component);

exports.default = Formit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-formit/dist/formit.js
// module id = 358
// module chunks = 0